export const columnClientVoucherList = [
  {
    key: "client_code",
    label: "Client Code",
    filter: false,
    sorter: true
  },
  {
    key: "is_used",
    label: "Used?",
    filter: false,
    sorter: false
  },
  {
    key: "is_game_pass",
    label: "Game Pass?",
    filter: false,
    sorter: false
  },
  {
    key: "createdAt",
    label: "Create Date",
    filter: false,
    sorter: false
  },
  {
    key: "action",
    label: "",
    filter: false,
    sorter: false
  },
]

export const columnGameVoucherList = [
  {
    key: "voucher_code",
    label: "Vouce Code",
    filter: false,
    sorter: true
  },
  {
    key: "is_used",
    label: "Used?",
    filter: false,
    sorter: false
  },
  {
    key: "game_name",
    label: "Game",
    filter: false,
    sorter: false
  },
  {
    key: "expired_date",
    label: "Expired Date",
    filter: false,
    sorter: false
  },
  {
    key: "createdAt",
    label: "Create Date",
    filter: false,
    sorter: false
  },
  {
    key: "action",
    label: "",
    filter: false,
    sorter: false
  },
]

export const columnGameList = [
  {
    key: "game_name",
    label: "Game Name",
    filter: false,
    sorter: true
  },
  {
    key: "is_active",
    label: "Active?",
    filter: false,
    sorter: false
  },
  {
    key: "createdAt",
    label: "Create Date",
    filter: false,
    sorter: false
  },
  {
    key: "action",
    label: "",
    filter: false,
    sorter: false
  },
]

export const columnClaimHistoryList = [
  {
    key: "client_code",
    label: "Client Code",
    filter: false,
    sorter: true
  },
  {
    key: "mlbb_account_id",
    label: "MLBB Account ID",
    filter: false,
    sorter: true
  },
  {
    key: "mlbb_zone",
    label: "MLBB Zone",
    filter: false,
    sorter: true
  },
  {
    key: "claim_status",
    label: "Claim Status",
    filter: false,
    sorter: false
  },
  {
    key: "reference",
    label: "Reference",
    filter: false,
    sorter: false
  },
  {
    key: "createdAt",
    label: "Create Date",
    filter: false,
    sorter: true
  },
  {
    key: "failed_reason",
    label: "Failed Reason",
    filter: false,
    sorter: false
  },
  {
    key: "action",
    label: "",
    filter: false,
    sorter: false
  },
]

export const columnClaimHistoryGameList = [
  {
    key: "voucher_code",
    label: "Voucher Code",
    filter: false,
    sorter: true
  },
  {
    key: "game_name",
    label: "Game",
    filter: false,
    sorter: true
  },
  {
    key: "createdAt",
    label: "Claim Date",
    filter: false,
    sorter: false
  },
]